import SVPageMargins from '@pkgs/shared-client/components/SVPageMargins';
import SVPageNav from '@pkgs/shared-client/components/SVPageNav';
import SVPageNavLayout from '@pkgs/shared-client/components/SVPageNavLayout';

export const Section = (props: OnlyChildrenProps) => (
	<SVPageMargins>
		<div className="type-base mx-auto mb-16 mt-0 max-w-3xl" {...props} />
	</SVPageMargins>
);

export const SectionTitle = (props: OnlyChildrenProps) => (
	<h2 className="type-subtitle mb-4 text-left font-semibold" {...props} />
);

export const Spacer = () => <div className="mt-4" />;

export const SubsectionTitle = (props: OnlyChildrenProps) => (
	<h3 className="type-pagenav mt-4 font-semibold" {...props} />
);

export const SVLegalPageNavContainer = ({ children }: OnlyChildrenProps) => {
	const items = [
		{ to: '/terms', label: 'Terms of Service' },
		{ to: '/privacy', label: 'Privacy Policy' },
		{ to: '/community-guidelines', label: 'Community Guidelines' },
		{ to: '/copyright-policy', label: 'Copyright Policy' },
		{ to: '/trademark-policy', label: 'Trademark Policy' },
		{ to: '/platform-enforcement-policy', label: 'Platform Enforcement Policy' },
		{ to: '/notice-for-non-users', label: 'Notice for Non-Users' },
	];

	return <SVPageNavLayout navigation={<SVPageNav items={items} />}>{children}</SVPageNavLayout>;
};
